import StopWatch from './StopWatch';
import { Root } from './styles';
import TimerForm from './TimerForm';
import useTimerCard from './vm';

export interface TimerCardProps {
  className?: string;
}

const TimerCard = ({ className }: TimerCardProps) => {
  const { isPresenting } = useTimerCard();

  return <Root className={className}>{isPresenting ? <StopWatch /> : <TimerForm />}</Root>;
};

export default TimerCard;
